import components from './components'
import * as vuex from './vuexstore'
import { beforeReady, ready } from './lib/init'
import { addiesaasBeforeReady, addiesaasReady, EventBus } from 'utils/vue/lib/utils'

addiesaasBeforeReady(beforeReady)
addiesaasReady(ready)

EventBus.$on('addiesaas.app.init', VueApp => {
    for (const component of VueApp.$children) {
        EventBus.$emit('renderer.rendered.' + component.$options._componentTag)
    }
})

export default {
    components,
    vuex,
}
